import React from 'react';
import { Tooltip } from 'primereact/tooltip';

function PrimeReactTooltip(props) {
  const { children = null, target, position = '', className = '', ...rest } = props || {};
  return (
    <>
      <Tooltip target={target} position={position} className={className} {...rest}>
        {children ? children : null}
      </Tooltip>
    </>
  );
}

export default PrimeReactTooltip;
